import React, { Suspense } from 'react';
import { useStyles } from './styles/global';
import Routes from './routes';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
   const classes = useStyles();

   return (
      // <Suspense fallback={<div>Loading...</div>}>
      <div className={classes['@global']}>
         <BrowserRouter>
            <Routes />
            <ToastContainer style={{ width: '500px' }} limit={1} />
         </BrowserRouter>
      </div>
      // </Suspense>
   );
}

export default App;
